import { Tooltip, Typography } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import { MutableRefObject, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

interface TruncatedTextProps {
  text: string;
  maxLength?: number;
  showTooltip?: boolean;
  href?: string;
  disabled?: boolean
  clampRef?: MutableRefObject<HTMLElement|null>;
}

export function TruncatedText ({ text, maxLength = 50, showTooltip = true, href, disabled, clampRef }: TruncatedTextProps) {

  const [showMobileTooltip, setShowMobileTooltip] = useState(false);
  const theme = useTheme();
  const navigate = useNavigate();

  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    if (!clampRef?.current) return;

    const el = clampRef.current;
    const checkTruncation = () => {
      setIsTruncated(el.scrollHeight > el.clientHeight);
    };

    checkTruncation();

    const resizeObserver = new ResizeObserver(checkTruncation);
    resizeObserver.observe(el);

    return () => resizeObserver.disconnect();
  }, [clampRef, text]);

  return (
    <Tooltip
      aria-hidden="true"
      title={ showTooltip &&  ((text.length > maxLength) || isTruncated) ? (
        <Typography variant={ "subtitle2" }>{ text }</Typography>
      ) : null }
      placement={ "top" }
      open={ showMobileTooltip }
      onOpen={ () => setShowMobileTooltip(true) }
      onClose={ () => setShowMobileTooltip(false) }
      PopperProps={ { style: { pointerEvents: "none", zIndex: 10001 } } }
      slotProps={ {
        popper: {
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, -5]
              }
            }
          ]
        },
        tooltip: {
          style: {
            backgroundColor: alpha(theme.customColors.backgroundPrimary, 0.9),
            color: theme.customColors.textPrimary
          }
        }
      } }
    >
      <span 
        role={ "presentation" } 
        onClick={ () => {
          setShowMobileTooltip(true);
          if(href && !disabled) navigate(href);
        } } 
        style={ { 
          cursor: (href && !disabled) ? "pointer" : "inherit" ,
          display: "-webkit-box",
          fontSize: "1rem", 
          lineHeight: "1.25rem", 
          overflow: "hidden",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 2
        } }
      >
        { text }
      </span>
    </Tooltip>
  );
}
